/**
 * Notification type codes returned by GetNotificationTypes API.
 * Only includes codes used for mapping toggles in System Notifications.
 */
export const NotificationTypeCode = {
  /** Buyer Purchase Orders: all of these must be present to toggle on */
  enaPOSubmitApproval: 521,
  enaPOApprove: 522,
  enaPODeclines: 523,
  enaPOBuyerSubmits: 524,
  enaPOAccepted: 525,
  enaPORejected: 526,
  enaPOTransferred: 527,
  enaPOSupplierRouted: 543,
  enaPOSupplierTransfer: 567,
  enaPORecalledManager: 716,
  enaPORecalledSupplier: 717,
  /** Invoices */
  RCVBuyerSubmits: 539,
  RCVSupplierCompletes: 540,
  /** OCR */
  enaOCR: 818,
  /** Internal messages: both must be present to toggle on */
  enaMSGsent: 534,
  enaMSGResponse: 536,
} as const;

export type NotificationTypeCodeValue =
  (typeof NotificationTypeCode)[keyof typeof NotificationTypeCode];

/** Codes required for Buyer Purchase Orders toggle */
export const BUYER_PO_CODES = [
  NotificationTypeCode.enaPOSubmitApproval,
  NotificationTypeCode.enaPOApprove,
  NotificationTypeCode.enaPODeclines,
  NotificationTypeCode.enaPOBuyerSubmits,
  NotificationTypeCode.enaPOAccepted,
  NotificationTypeCode.enaPORejected,
  NotificationTypeCode.enaPOTransferred,
  NotificationTypeCode.enaPOSupplierRouted,
  NotificationTypeCode.enaPOSupplierTransfer,
  NotificationTypeCode.enaPORecalledManager,
  NotificationTypeCode.enaPORecalledSupplier,
] as const;

/** Codes required for Invoices toggle */
export const INVOICES_CODES = [
  NotificationTypeCode.RCVBuyerSubmits,
  NotificationTypeCode.RCVSupplierCompletes,
] as const;

/** Code for OCR toggle */
export const OCR_CODE = NotificationTypeCode.enaOCR;

/** Codes required for Messages toggle */
export const MESSAGES_CODES = [
  NotificationTypeCode.enaMSGsent,
  NotificationTypeCode.enaMSGResponse,
] as const;
